var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGimnasio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3392_14362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1269 7.66309H20.5214C20.9062 7.66309 21.2186 7.97544 21.2186 8.36031V15.3326C21.2186 15.7174 20.9062 16.0298 20.5214 16.0298H19.1269C18.742 16.0298 18.4297 15.7174 18.4297 15.3326V8.36031C18.4297 7.97544 18.742 7.66309 19.1269 7.66309Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3378 4.875H17.7323C18.1172 4.875 18.4295 5.18736 18.4295 5.57222V18.1223C18.4295 18.5071 18.1172 18.8195 17.7323 18.8195H16.3378C15.953 18.8195 15.6406 18.5071 15.6406 18.1223V5.57222C15.6406 5.18736 15.953 4.875 16.3378 4.875Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58004 4.875H7.97449C8.35936 4.875 8.67171 5.18736 8.67171 5.57222V18.1223C8.67171 18.5071 8.35936 18.8195 7.97449 18.8195H6.58004C6.19517 18.8195 5.88281 18.5071 5.88281 18.1223V5.57222C5.88281 5.18736 6.19517 4.875 6.58004 4.875Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78707 7.66309H5.18152C5.56639 7.66309 5.87874 7.97544 5.87874 8.36031V15.3326C5.87874 15.7174 5.56639 16.0298 5.18152 16.0298H3.78707C3.4022 16.0298 3.08984 15.7174 3.08984 15.3326V8.36031C3.08984 7.97544 3.4022 7.66309 3.78707 7.66309Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2188 11.8457H23.3104",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67188 11.8457H15.6441",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.8457H3.09167",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3392_14362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGimnasio);
export default __webpack_public_path__ + "static/media/Gimnasio.a3794daa0c9491543f68b98272d00e69.svg";
export { ForwardRef as ReactComponent };